<template>
  <div class="callListVue" v-loading="loading">
    <div v-if="job&&isEmployeeAllowed">
      <div class="o-main-content-area">
        <div class="o-main-content-area--padBotoomNone">
            <div class="row c-responsive-fixwidth">
                <div class="col-md-6">
                    <h1 class="h1">Jobs / Events:<a @click="backToJobDetails">{{" "+ title}}</a></h1>
                </div>
            </div>
            <div class="c-responsive-fixwidth">
                <div class="col-md-12 o-tab-area o-no-padding">
                    <ul class="o-tab-view o-tab-view--text">
                        <li href="javascript: void(0)" @click="goToViewCalls()"><a class="call-deactive">Calls</a></li>
                        <li href="javascript: void(0)" @click="goToPhoneSheet()"><a class="call-deactive">PhoneSheet</a></li>
                        <li @click="backToJobDetails()"><a href="javascript: void(0)" class="call-deactive">Job Details</a></li>
                        <li @click="gotoJobAttendance()"><a href="javascript: void(0)" class="active">Attendance</a></li>
                    </ul>
                </div>
            </div>
        </div>

        <div class="c-responsive-fixwidth">
          <div v-if="itemsSource.length > 0"> 
            <div
              class=""
              v-for="(items,index) in itemsSource"
              :key="items.callDate"
            >
              <ul class="o-tab-view o-tab-view--text date_assign">
                <li class="o-inline-block">
                  <div class="date">                 
                  <label v-if="dateWiseCheckField && dateWiseCheckField.length>0">
                        <input type="checkbox" :name="'dateCheck'+index" v-model="dateWiseCheckField[index].dateCheck" @change="updateSubSelection(index,items)">
                    </label>
                    <span class="date-block">
                      <i class="fa fa-calendar"></i>
                      {{ setDate(items.callDate) }}
                    </span>
                    <span class="mr-10">
                      Action:
                      <select v-model="dateWiseCheckField[index].selectedBulkAction" @change="performBulkAction(index)" class="">
                        <option value="" disabled>Select Action</option>
                        <option value="arrived">Arrived</option>
                        <option value="confirm">Confirmed/Clear</option>
                        <!-- <option value="late">Late</option>
                        <option value="no_show">No Show</option>
                        <option value="sent_home">Sent Home</option> -->
                        <!-- <option value="callout">Callout</option> -->
                      </select>
                      <span class="o-custom-drop-arrow"><i class="fa fa-angle-down" aria-hidden="true"></i></span>
                    </span>
                    <span class="mr-10">
                      Sort By:
                      <select v-model="selectedSortType" @change="getData()" class="">
                        <option value="fname_asc">FirstLast (Employee name)</option>
                        <option value="fname_desc">LastFirst (Employee name)</option>
                      </select>
                      <span class="o-custom-drop-arrow"><i class="fa fa-angle-down" aria-hidden="true"></i></span>
                    </span>                  
                  </div>
                </li>
              </ul>

              <wj-flex-grid
                headersVisibility="Column"
                :deferResizing="true"
                :showMarquee="true"
                :alternatingRowStep="0"
                :initialized="initializeGrid"
                :itemsSource="items.data"
              >
                <wj-flex-grid-cell-template cellType="TopLeft">
                  <template slot-scope="TopLeft"> No </template>
                </wj-flex-grid-cell-template>

                <wj-flex-grid-column
                  :isReadOnly="true"
                  :width="40"
                  header="   "
                  :binding="'selected'"
                >
                  <wj-flex-grid-cell-template cellType="Cell">
                    <template slot-scope="cell">    
                        <label>
                            <input @change="onUpdateSubInput(index,cell)" type="checkbox" :name="'check'+index" :value="cell.item.id" v-model="cell.item.selected">
                            <span class="cr"><i class="cr-icon fa fa-check"></i></span>
                        </label>

                    </template>
                  </wj-flex-grid-cell-template>
                </wj-flex-grid-column>
                

                <wj-flex-grid-column
                  binding="start"
                  header="Start"
                  :isReadOnly="true"
                  :width="80"
                />

                <wj-flex-grid-column
                  binding="end"
                  header="End"
                  :isReadOnly="true"
                  :width="80"
                />

                <wj-flex-grid-column
                  binding="position"
                  header="Position"
                  :isReadOnly="true"
                  :width="180"
                />

                <wj-flex-grid-column
                  :isReadOnly="true"
                  :width="300"
                  header="Employee"
                  :binding="'employee'"
                >
                  <!-- <wj-flex-grid-cell-template cellType="Cell">
                    <template :slot-scope="cell"> 
                      {{ cell.item.employee? cell.item.employee:"" }}
                      <el-tooltip class="item" effect="dark" content="Confirmed" placement="top-end">
                        <i v-if="cell.item.call_status=='Confirmed'" aria-hidden="true" class="fa fa-check confirm-check-icon-style el-tooltip item" aria-describedby="el-tooltip-5474" tabindex="0"></i>
                      </el-tooltip>
                    </template>
                  </wj-flex-grid-cell-template> -->
                </wj-flex-grid-column>

                <wj-flex-grid-column
                  :isReadOnly="true"
                  :width="65"
                  header="Arrived"
                  :binding="'arrived'"
                >
                  <wj-flex-grid-cell-template cellType="Cell">
                    <template slot-scope="cell">                    
                        <a href="javascript: void(0)" class="action_div" :class="{ 'go-bg-green': cell.item.attendance_status=='Arrived' }" @click="performAction(cell,'arrived')">
                          <el-tooltip class="item" effect="dark" content="Arrived" placement="top-end">                                                    
                              <!-- <i class="fa fa-phone" aria-hidden="true"></i>                           -->
                              <i class="fa fa-check" :class="{ 'go-font-white': cell.item.attendance_status=='Arrived' }" aria-hidden="true"></i>                          
                          </el-tooltip>
                        </a>
                    </template>
                  </wj-flex-grid-cell-template>
                </wj-flex-grid-column>

                <wj-flex-grid-column
                  :isReadOnly="true"
                  :width="65"
                  header="Late"
                  :binding="'late'"
                >
                  <wj-flex-grid-cell-template cellType="Cell">
                    <template slot-scope="cell">                    
                        <a href="javascript: void(0)" class="action_div" :class="{'go-bg-orange': cell.item.attendance_status=='Late'}" @click="performAction(cell,'late')">
                          <el-tooltip class="item" effect="dark" content="Late" placement="top-end">                                                    
                              <i class="fa fa-history" aria-hidden="true" :class="{'go-font-white': cell.item.attendance_status=='Late'}"></i>                          
                          </el-tooltip>
                        </a>
                    </template>
                  </wj-flex-grid-cell-template>
                </wj-flex-grid-column>

                <wj-flex-grid-column
                  :isReadOnly="true"
                  :width="65"
                  header="No Show"
                  :binding="'no_action'"
                >
                  <wj-flex-grid-cell-template cellType="Cell">
                    <template slot-scope="cell">                    
                        <a href="javascript: void(0)" class="action_div" @click="performAction(cell,'no_show')">
                          <el-tooltip class="item" effect="dark" content="No-Show" placement="top-end">                                                    
                              <i class="fa fa-question-circle" aria-hidden="true"></i>                          
                          </el-tooltip>
                        </a>
                    </template>
                  </wj-flex-grid-cell-template>
                </wj-flex-grid-column>

                <wj-flex-grid-column
                  :isReadOnly="true"
                  :width="80"
                  header="Sent Home"
                  :binding="'sent_home'"
                >
                  <wj-flex-grid-cell-template cellType="Cell">
                    <template slot-scope="cell">                    
                        <a href="javascript: void(0)" class="action_div" @click="sentHome(cell.item)">
                          <el-tooltip class="item" effect="dark" content="Sent-Home" placement="top-end">                                                    
                              <i class="fa fa-bus" aria-hidden="true"></i>                          
                          </el-tooltip>
                        </a>
                    </template>
                  </wj-flex-grid-cell-template>
                </wj-flex-grid-column>

                <wj-flex-grid-column
                  :isReadOnly="true"
                  :width="80"
                  header="Callout"
                  :binding="'callout'"
                >
                  <wj-flex-grid-cell-template cellType="Cell">
                    <template slot-scope="cell">                    
                          <!-- Callout -->
                        <a href="javascript: void(0)" class="action_div" @click="callOut(cell.item)">
                          <el-tooltip class="item" effect="dark" content="Callout" placement="top-end">                                                    
                              <i class="fa fa-phone go-red" aria-hidden="true"></i>                         
                          </el-tooltip>
                        </a>
                    </template>
                  </wj-flex-grid-cell-template>
                </wj-flex-grid-column>

              </wj-flex-grid>
            </div>
          </div>

          <div v-else class="mt-4">
            <div class="c-common-gradient">
                <div class="col-md-12 no-job-dispaly">
                <i class="fa fa-frown-o" aria-hidden="true"></i>
                <br />
                    No Data Stored
                </div>
            </div>
          </div>
        </div>
      </div>

      <modal
        name="add-note-callout-decline"
        height="auto"
        :scrollable="false"
        class="modal-dialog modal-sm modal--custom"
        @closed="openCloseAddNoteModal('close', null)"
      >
        <div tabindex="-1" role="dialog">
          <div role="document">
            <div class="modal-content">
              <div class="modal-header text-center">
                <button
                  @click="openCloseAddNoteModal('close', null)"
                  type="button"
                  class="close custom-modal--close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
                <h1 class="modal-title" v-if="selectedJob">Add Note</h1>
              </div>
              <div class="modal-body mt-15" v-if="addNoteDilog">
                <form>
                  <div class="row">
                    <div class="col-sm-12 o-no-padding">
                      <div class="col-md-5 o-right-no-padding o-calender-area">
                        <div class="o-calls-table">
                          <div class="o-calender-details-list">
                            <el-form :model="addNoteDialogForm">
                              <el-form-item label="Note">
                                <el-input
                                  v-model="addNoteDialogForm.note"
                                ></el-input>
                              </el-form-item>
                            </el-form>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>

              <div class="modal-footer text-center">
                <span slot="footer" class="dialog-footer">
                  <el-button @click="openCloseAddNoteModal('close', null)"
                    >Cancel</el-button
                  >
                  <el-button
                    type="primary"
                    :disabled="disabled"
                    @click="
                      performCallouDeclineActions(
                        callData,
                        addNoteDialogForm.note
                      )
                    "
                    >{{ action == 'sent_home'?'Sent Home' : action }}</el-button
                  >
                </span>
              </div>
            </div>
          </div>
        </div>
      </modal>
      <div v-if="openOtherConflictsModal">
        <modal
          name="otbConflictPop"
          height="auto"
          :scrollable="false"
          class="modal-dialog modal-sm modal--custom"
        >
          <div tabindex="-1" role="dialog">
            <div role="document">
              <div class="modal-content o-common-modal-content">
                <div class="modal-header text-center">
                  <button
                    @click="closeOtbConflictPop()"
                    type="button"
                    class="close custom-modal--close"
                    data-dismiss="modal"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                  <h1 class="modal-title">WARNING !</h1>
                </div>
                <div class="modal-body">
                  <div class="obt-conflict-body">
                    Selecting this user will create the opportunity for a 2x
                    Booking in another client. Proceed with Caution and make
                    direct contact with the employee!
                  </div>
                </div>

                <div class="modal-footer text-center">
                  <a
                    id="btn-bulk-assign-modal"
                    href="javascript: void(0)"
                    @click="closeOtbConflictPop()"
                    class="c-common-btn c-common-btn--small obt-modal-cancel-btn"
                  >
                    Cancel</a
                  >
                  <a
                    id="btn-bulk-assign-modal"
                    href="javascript: void(0)"
                    @click="proceedWithConflict(selectedEmployeeID)"
                    class="c-common-btn c-common-btn--small obt-modal-proceed-btn"
                    >Proceed</a
                  >
                </div>
              </div>
            </div>
          </div>
        </modal>
      </div>
    </div>
    <div v-else-if="!isEmployeeAllowed">
        <NotAllowed />
    </div>
  </div>
</template>

<script>
import "@grapecity/wijmo.styles/wijmo.css";
import * as wjcCore from "@grapecity/wijmo";
import "@grapecity/wijmo.vue2.input";
import "@grapecity/wijmo.vue2.grid";
import "@grapecity/wijmo.vue2.core";
import service from "../../services.js";
import dateTimeConvert from "../../timeConvert&Compare.js";
import { mapGetters } from "vuex";
import { CollectionView } from "@grapecity/wijmo";
import callListConflicts from "./callListConflicts.vue";
import NotAllowed from '@/components/NotAllowed';
import _ from "lodash";

wjcCore.setLicenseKey(
  //wijmo license key goes here
  "iatse126.callsteward.com|iatse442.callsteward.com|ia77.callsteward.com|iatse917.callsteward.com|iatselocal415.callsteward.com|cs3demo.callsteward.com|iatse631.callsteward.com|iatse838.callsteward.com|ia118.callsteward.ca|iatse97.callsteward.com|iatse336.callsteward.com|iatse768.callsteward.com|shadowmonkey.callsteward.com|callsteward.com|ia127.callsteward.com|dev-callsteward.com|iatse56.callsteward.ca|iatse482.callsteward.com|townevents.callsteward.com|iatse347.callsteward.com|tristate.callsteward.com|iatse99.callsteward.com|iatse614.callsteward.com|iatse251.callsteward.com|ia67.callsteward.com|iatse66.callsteward.com|iatse134.callsteward.com|iatse900.callsteward.com|ia865.callsteward.com|ia195.callsteward.com|bayou.callsteward.com|iatse285.callsteward.com|mmcpa.callsteward.com|iatse140.callsteward.com|iatse284.callsteward.com|ia158.callsteward.com|cs3demo.dev-callsteward.com|iatse55.callsteward.com|iatse200.callsteward.com|stagecraftltd.callsteward.com|ia322.callsteward.com|bsu.callsteward.com|iatse93.callsteward.com|iatse574.callsteward.com|iatse803.callsteward.com|iatse24.callsteward.com|cbf.callsteward.com|iatse504.callsteward.com|iatse26.callsteward.com|iatse51.callsteward.com|iatse85.callsteward.com|iatse500.callsteward.com|iatse50.callsteward.com|boreal.callsteward.com|lrmteam.callsteward.com|iatse69.callsteward.com|iatse363.callsteward.com|iatse470.callsteward.com|login.callsteward.ca|iatse4.callsteward.com|iatse82.callsteward.com|iatse2.dev-callsteward.com|ia193.callsteward.com|iatse18.callsteward.com|ia632.callsteward.com|gorhamst.callsteward.com|iatse417.callsteward.com|osu.callsteward.com|iatse205.callsteward.com|ia329.callsteward.com|ia87.callsteward.com|iatse217.callsteward.com|monument.callsteward.com|iatse339.callsteward.com|iatse9.callsteward.com|iatse30.callsteward.com|iatse114.callsteward.com|iatse354.callsteward.com|iatse58.callsteward.ca|ia220.callsteward.com|pyrospec.callsteward.com|iatse17.callsteward.com|iatse2.callsteward.com|iatse321.callsteward.com|lpem.callsteward.com|ia115.callsteward.com|ia3.callsteward.com|iatse421.callsteward.com|ia60.callsteward.com|nice.callsteward.com|iatse665.callsteward.com|ia333.callsteward.com|iatse63.callsteward.ca|iatse919.callsteward.com|volt.callsteward.com|anchorstage.callsteward.com|stage-callsteward.com|iatse675.callsteward.com|iatse112.callsteward.com|iatse107.callsteward.com|cc.callsteward.com|iatse22.callsteward.com|ia76.callsteward.com|iatse250.callsteward.ca|sss.callsteward.com|ia918.callsteward.com|callsteward.ca|ia8.callsteward.com|login.callsteward.com|ia8.dev-callsteward.com|iatse357.callsteward.ca|iatse618.callsteward.com|ia611.callsteward.com|iatse42.callsteward.com|ia232.callsteward.com|iatse31.callsteward.com|callsteward.uk|iatse187.callsteward.com|iatse461.callsteward.ca|ia274.callsteward.com|iatse19.callsteward.com|iatse59.callsteward.com|iatse635.callsteward.com|kimmel.callsteward.com|iatse11.callsteward.com|iatse16.callsteward.com|iatse33.callsteward.com,844573782754749#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#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"
);

export default {
  computed: {
    ...mapGetters({
      userToken: "userToken",
      userRole: "userRole",
      userClientID: "userClientID",
      userID: "userID",
      subDomain: "getSubdomain",
      callStatus: "callStatus",
      clientDetails: "clientDetails",
      userName: "userName",
      userFirstName: "userFirstName",
      userFullName: "userFullName",
      employeeId: "employeeId",
    }),
  },

  components: {
    'callListConflicts': callListConflicts,
    'NotAllowed': NotAllowed
  },

  data() {
    return {
      isEmployeeAllowed: true,
      client: null,
      lastDate: '',
      job: null,
      title: '',
      employee_work_status: null,
      afterApi: null,
      timeout:  null,
      tableapiheaders: {
        employee_id: "employeeId",
        time_frame: "15",
        next_bantch_type: "",
      },
      searchlist: [],
      senioritySearchList: [],
      lastOfferSearchList: [],
      senioritySearchEmployee: null,
      // lastOfferSearchEmployee: null,
      searchEmployee: "",
      addNoteDialogForm: {
        note: "",
      },
      selectedJob: {},
      callData: null,
      action: null,
      modalDataLoad: false,
      loading: false,
      addNoteDilog: false,
      selectedEmployeeID: null,
      selectedEmployeeLastOffer: null,
      openOtherConflictsModal: false,
      itemsSource: [],
      userDateFormat: "dddd  Do, MMMM, YYYY",
      turnoverTime: "",
      timer: "",
      pass_option:0,
      selectedEmployeePhone: "",
      selectedSortType: 'fname_asc',
      selectBulkAction: '',
      selectedDayAllCalls: false,
      checked: false,
      dateWiseCheckField: [],
      api_data: null,
      selectedCallIds: [],
      selectedGroupCallIndex: -1,
      disabled: false
    };
  },

  async created() {
    // this.client = JSON.parse(JSON.stringify(this.clientDetails));
    await this.jobDetails();
    await this.getData();
    await this.getClientDetails();
    if (this.client) {
      this.turnoverTime = this.client.turnover;
      this.pass_option = this.client.pass_option
    }
    this.tableapiheaders.employee_id = $cookies.get("CallListEmployeeId")
      ? $cookies.get("CallListEmployeeId")
      : this.employeeId;
    if (!$cookies.get("CallListEmployeeId")) {
      $cookies.set("CallListEmployeeId", this.employeeId);
      $cookies.set("CallListEmployeeName", this.userFullName);
    } else {
      if ($cookies.get("CallListEmployeeId") !== this.employeeId) {
        this.searchEmployee = $cookies.get("CallListEmployeeName");
      }
    }    
    // this.timer = setInterval(this.getData, 60000);
  },

  methods: {
    getRoundOffSkillSeniority(seniorityVal) {     
        // console.log(seniorityVal); 
        if(seniorityVal && seniorityVal != '') {          
            if(seniorityVal.valueOf() == parseInt(seniorityVal)){
                let x = parseInt(seniorityVal);
                return x;
            }
        }
        return seniorityVal;
    },

    async getClientDetails() {
      await service.get('client/' + this.userClientID, {
                'Authorization': this.userToken
            }).
            then((res) => {                
                this.client=res.data.result;
                // this.getNext45DaySchedule();
            }).catch((err) => {
                console.log(err);
            });  
    },

    setDate(date) {
      return dateTimeConvert.globalDate(date, this.userDateFormat);
    },

    async getData() {
      this.$Progress.start();
      this.loading = true;
      this.afterApi = false;
      var api_data = [];
      await service
        .get("job/"+atob(this.$route.params.jobId)+"/confirmedCall", {
          authorization: this.userToken,
          'cs3-context-role': this.userRole,
          'cs3-context-clientId': this.userClientID,
          'sort': this.selectedSortType
        })
        .then((res) => {
          api_data = res.data.result;
          this.api_data = api_data;
          this.$Progress.finish();
          this.filesList = res.data.result;
          this.afterApi = true;
          var tempdata = [];
          this.dateWiseCheckField=[];
          for (let date in api_data) {
            let sampleData = {
              dateCheck: false,
              callUnderDate: [],
              selectedBulkAction: '',
              callsLength: api_data[date].length,
            };
            
            this.dateWiseCheckField.push(sampleData);
            // console.log(this.dateWiseCheckField);

            tempdata.push({
              callDate: date,
              data: this.getCallData(api_data[date]),
            });
          }
          // console.log(this.dateWiseCheckField);
          this.loading = false;
          var sortedTempdata = tempdata.sort((a, b) => b.date - a.date);
          this.itemsSource = sortedTempdata;
        })
        .catch((err) => {
          console.log(err);
          this.$Progress.finish();
          this.modalDataLoad = false;
          this.afterApi = true;
          this.loading = false;
          if(err.response&&err.response.status&&err.response.status==403) {
              this.isEmployeeAllowed = false;
              this.$notify({
                  title: 'Important message',
                  message: "You don't have Access!",
                  type: 'error'
              });
              this.$router.push({path: '/schedule/', params: {empId: btoa(this.employeeId)}});
          }
        });
    },

    getCallData(Data) {
      var data = [];
      for (let index in Data) {
        data.push({
          id: Data[index].id,
          position: Data[index].skill.name,
          start:
            ("0" + new Date(Data[index].start).getHours()).slice(-2) +
            "" +
            ("0" + new Date(Data[index].start).getMinutes()).slice(-2),
          end:
            ("0" + new Date(Data[index].end).getHours()).slice(-2) +
            "" +
            ("0" + new Date(Data[index].end).getMinutes()).slice(-2),
          employee_id: Data[index].employee_id,
          employee: Data[index].employee&&Data[index].employee.employable
            ? this.selectedSortType == 'fname_asc' ? 
              Data[index].employee.employable.first_name + ' ' + Data[index].employee.employable.last_name 
              : Data[index].employee.employable.last_name + ', ' + Data[index].employee.employable.first_name
            : '',
          arrived: true,
          late: true,
          no_show: true,
          sent_home: true,
          call_out: true,
          selected: false,
          attendance_status: Data[index].attendance_status ? Data[index].attendance_status.name : null,
          call_status: Data[index].status ? Data[index].status.name : null
        });
      }
      var collect = new CollectionView(data, {
        groupDescriptions: ["job"],
      });
      return collect;
    },
    
    getChangeCallData(Data) {
      var data = [];
      for (let index in Data) {
        data.push({
          id: Data[index].id,
          position: Data[index].skill.name,
          start:
            ("0" + new Date(Data[index].start).getHours()).slice(-2) +
            "" +
            ("0" + new Date(Data[index].start).getMinutes()).slice(-2),
          end:
            ("0" + new Date(Data[index].end).getHours()).slice(-2) +
            "" +
            ("0" + new Date(Data[index].end).getMinutes()).slice(-2),
          employee_id: Data[index].employee_id,
          employee: Data[index].employee&&Data[index].employee.employable
            ? this.selectedSortType == 'fname_asc' ? 
              Data[index].employee.employable.first_name + ' ' + Data[index].employee.employable.last_name 
              : Data[index].employee.employable.last_name + ', ' + Data[index].employee.employable.first_name
            : '',
          arrived: true,
          late: true,
          no_show: true,
          sent_home: true,
          call_out: true,
          selected: true,
          attendance_status: Data[index].attendance_status ? Data[index].attendance_status.name : null,
          call_status: Data[index].status ? Data[index].status.name : null
        });
      }
      var collect = new CollectionView(data, {
        groupDescriptions: ["job"],
      });
      return collect;
    },

    updateSubSelection(index,calls) {
      this.selectedCallIds = [];
      let tempdata = [];
      for (let date in this.api_data) {
        if(calls.callDate != date) {
          tempdata.push({
            callDate: date,
            data: this.getCallData(this.api_data[date]),
          });
        } else {
          tempdata.push({
            callDate: date,
            data: this.dateWiseCheckField[index].dateCheck ? this.getChangeCallData(this.api_data[date]):this.getCallData(this.api_data[date]),
          });
        }
      }
      if(this.dateWiseCheckField[index].dateCheck) {
        this.selectedGroupCallIndex = index;
        for(let idx = 0; idx<calls.data._src.length;idx++) {
          this.selectedCallIds.push(calls.data._src[idx].id)
        }
      }else {
        this.selectedGroupCallIndex = -1;
      }
      // console.log(this.selectedCallIds);
      this.loading = false;
      var sortedTempdata = tempdata.sort((a, b) => b.date - a.date);
      this.itemsSource = sortedTempdata;      
    },

    initializeGrid(flex) {
      // flex.collapseGroupsToLevel(-1);
    },

    openCloseAddNoteModal(type, call) {
      this.callData = call;
      if (type == "open") {
        this.addNoteDilog = true;
        this.$modal.show("add-note-callout-decline");
      } else {
        this.addNoteDilog = false;
        this.$modal.hide("add-note-callout-decline");
      }
    },

    async performCallouDeclineActions(call, value) {
      var activityID = {
        uploader_id: this.userID,
        uploaded_by: this.userFullName,
      };
      this.loading = true;

      if(this.action == 'Callout') {  
        this.disable = true;        
        await service
          .post(
            "call/" + call.id + "/callout",
            {
              user_id: this.userID,
              activity: JSON.stringify(activityID),
              note_content: value,
            },
            {
              authorization: this.userToken,
              "cs3-context-role": this.userRole,
              "cs3-context-clientId": this.userClientID,
            }
          )
          .then((res) => {
            this.disabled = false;
            this.$Progress.finish();
            this.addNoteDilog = false;
            this.$modal.hide("add-note-callout-decline");
            this.openCloseAddNoteModal('close', null);
            this.addNoteDialogForm.note = "";
            this.$notify({
              title: this.$t("success"),
              message: "Called Out successfully.",
              type: "success",
            });
            this.getData();
          })
          .catch((err) => {
            console.log(err);
            this.disabled = false;
            this.$Progress.finish();
            this.loading = false;
          });
      } else if(this.action == 'sent_home') {
        let formData =  {
          employeeId: call.employee_id,
          activity: JSON.stringify(activityID),
          note_content: value,
          status: this.action,
          userId: this.userID,
        };
        let header = {
          "Authorization": this.userToken,
          "cs3-context-role": this.userRole,
          "cs3-context-clientId": this.userClientID,
        };
        await service
        .put(`call/${call.id}/updateAttendance`, formData, header)
        .then((res) => {
              // console.log(res);
              this.$Progress.finish(); 
              this.addNoteDilog = false;
              this.$modal.hide("add-note-callout-decline");
              this.openCloseAddNoteModal('close', null);
              this.addNoteDialogForm.note = "";          
              this.$notify({
                title: this.$t("success"),
                message: 'Sent Home action updated successfully!',
                type: "success",
              });
              this.getData();
        })
        .catch((err) => {
          console.log(err);
          this.$notify({
            title: this.$t("error"),
            message: "Something went wrong",
            type: "error",
          });
          this.$Progress.finish();
          this.loading = false;
        });          
      }      
    },

    passCall(callId) {
      this.$confirm(
        "Are you sure you would like to pass this Call?",
        "Warning",
        {
          confirmButtonText: "OK",
          cancelButtonText: "Cancel",
          type: "warning",
        }
      )
        .then(() => {
          this.loading = true;
          service
            .put(
              "call/" + callId + "/pass",
              {
                user_id: this.userID,
              },
              {
                Authorization: this.userToken,
                "cs3-context-role": this.userRole,
                "cs3-context-clientId": this.userClientID,
              }
            )
            .then((res) => {
              this.$Progress.finish();
              this.$notify({
                title: "Success",
                message: "Call passed successfully.",
                type: "success",
              });
              this.getData();
            })
            .catch((err) => {
              console.log(err);
              this.$Progress.finish();
              this.loading = false;
            });
        })
        .catch(() => {});
    },

    clearAssign(callId) {
      this.$confirm(
        "Are you sure you would like to clear this Call? ",
        "Warning",
        {
          confirmButtonText: "OK",
          cancelButtonText: "Cancel",
          type: "warning",
        }
      )
        .then(() => {
          this.loading = true;
          service
            .del("call/" + callId + "/assign", {
              Authorization: this.userToken,
              "cs3-context-role": this.userRole,
              "cs3-context-clientId": this.userClientID,
              userId: this.userID,
              api_section: "phonesheet",
            })
            .then((res) => {
              this.$notify({
                title: "Success",
                message: "Call cleared successfully.",
                type: "success",
              });

              this.getData();
            })
            .catch((err) => {
              console.log(err);
              this.loading = false;
            });
        })
        .catch(() => {});
    },

    checkOtherBookingConflict(call) {
      if (this.checkAvailable(call)) {
        this.closeOtbConflictPop();
        this.assignEmployee($cookies.get("CallListEmployeeId"), call.call.id);
      }
    },

    checkAvailable(call) {
      if (call.call.is_available && call.call.vacation_info == null) {
        return true;
      } else {
        this.$notify({
          title: "Error",
          message: "User is not Available.",
          type: "error",
        });
        return false;
      }
    },

    closeOtbConflictPop() {
      this.$modal.hide("otbConflictPop");
      this.openOtherConflictsModal = false;
    },

    proceedWithConflict(emp_id) {
      this.closeOtbConflictPop();
      this.assignEmployee(emp_id);
    },

    async assignEmployee(employeeId, callId) {
      this.closeOtbConflictPop();
      $("#btn-" + employeeId).addClass("deactivate-btn");
      $("#btn-" + employeeId).addClass("deactivate-btn");
      this.loading = true;
      await service
        .put(
          "call/" + callId + "/assign",
          {
            employee_id: employeeId,
            status_id: this.callStatus,
            user_id: this.userID,
          },
          {
            Authorization: this.userToken,
            "cs3-context-role": this.userRole,
            "cs3-context-clientId": this.userClientID,
          }
        )
        .then((res) => {
          if (res.data.status_code == "1") {
            this.$notify({
              title: "Success",
              message: "Employee assigned Successfully.",
              type: "success",
            });
            this.getData();
          } else {
            this.loading = false;
            this.selectedEmployeesToAssign = [];
            this.$notify({
              title: "Error",
              message: res.data.status_message,
              type: "error",
            });
          }
        })
        .catch((err) => {
          this.loading = false;
          console.log(err);
          $("#btn-" + employeeId).removeClass("deactivate-btn");
          $("#btn-" + employeeId).removeClass("deactivate-btn");

          this.$notify({
            title: "Error",
            message:
              "Employee already booked please refresh your current page.",
            type: "error",
          });
        });
    },

    async undeclinedCall(call) {
      var actionlength = call.call.call_actions.length - 1;
      this.loading = true;
      await service
        .post(
          "call/undecline",
          {
            employee_id: this.tableapiheaders.employee_id,
            call_id: call.call.call_actions[actionlength].call_id,
            user_id: this.userID,
          },
          {
            Authorization: this.userToken,
            "cs3-context-role": this.userRole,
            "cs3-context-clientId": this.userClientID,
          }
        )
        .then((res) => {
          this.$Progress.finish();
          this.$notify({
            title: this.$t("success"),
            message: "Call undeclined successfully.",
            type: "success",
          });
          this.getData();
        })
        .catch((err) => {
          console.log(err);
          this.$Progress.finish();
          this.loading = false;
        });
    },

    setAction(callDetails) {
      var length = callDetails.call.call_actions.length;
      if (
        callDetails.action.status.name == "Confirmed" &&
        length > 0 &&
        callDetails.call.call_actions[length - 1].action_name == "Confirmed"
      ) {
        return 1; // pass
      } else if (callDetails.action.status.name == "Unassigned") {
        if (
          length > 0 &&
          ["Declined", "Call Out"].includes(
            callDetails.call.call_actions[length - 1].action_name
          )
        ) {
          return 2; // Undeclined
        } else {
          return 3; // Assign
        }
      } else if (callDetails.action.status.name == "Unconfirmed") {
        return 4; // Conform Decline Clear
      }
    },

    callOut(call) {
      this.disabled = true;
      this.action = "Callout";
      this.callData = call;
      this.$confirm("Do you want to called out?", "Warning", {
        confirmButtonText: "OK",
        cancelButtonText: "Cancel",
        type: "warning",
      })
        .then(() => {
          this.disabled = false;
          this.addNoteDilog = true;
          this.openCloseAddNoteModal("open", call);
        })
        .catch(() => {
          this.disabled = false;
          this.$message({
            type: "info",
            message: "Called Out canceled",
          });
        });
    },

    sentHome(call) {
      this.action = "sent_home";
      this.callData = call;
      this.$confirm("Do you want to Sent Home?", "Warning", {
        confirmButtonText: "OK",
        cancelButtonText: "Cancel",
        type: "warning",
      })
        .then(() => {
          this.addNoteDilog = true;
          this.openCloseAddNoteModal("open", call);
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "Sent Home canceled",
          });
        });
    },

    goToViewCalls() {
        this.$router.push({
            path: '/viewCalls/' + this.$route.params.jobId
        });
    },

    goToPhoneSheet() {
        this.$router.push({
            path: '/phoneSheet/' + this.$route.params.jobId
        });
    },

    backToJobDetails(){
        this.$router.push({
            path: `/jobDetails/`+this.$route.params.jobId
        });
    },

    gotoJobAttendance() {
        this.$router.push({
            path: `/jobAttendance/`+this.$route.params.jobId
        });
    },

    async jobDetails() {
        this.$Progress.start();
        await service.get('job/' + atob(this.$route.params.jobId), {
            'Authorization': this.userToken,
            'cs3-context-role': this.userRole,
            'cs3-context-clientId': this.userClientID
        }).
        then((res) => {
            this.job=res.data.result;
            this.$store.dispatch('saveJobDetails', res.data.result);
            this.title = this.job.title;           
            this.$Progress.finish();
        }).catch((err) => {
            console.log(err);
            if(err.response&&err.response.status&&err.response.status==403) {
                this.isEmployeeAllowed = false;
                this.$notify({
                    title: 'Important message',
                    message: "You don't have Access!",
                    type: 'error'
                });
                this.$router.push({path: '/schedule/', params: {empId: btoa(this.employeeId)}});
            }
        });
    },

    async performAction(callInfo,action) {         
      let formData =  {
        employeeId: callInfo.item.employee_id,
        status: action,
        userId: this.userID,
      };
      let header = {
        "Authorization": this.userToken,
        "cs3-context-role": this.userRole,
        "cs3-context-clientId": this.userClientID,
      };
      await service
       .put(`call/${callInfo.item.id}/updateAttendance`, formData, header)
       .then((res) => {
            // console.log(res);
            this.$Progress.finish();           
            this.$notify({
              title: this.$t("success"),
              message: action + ' action updated successfully!',
              type: "success",
            });
            this.getData();
          })
          .catch((err) => {
            console.log(err);
            this.$notify({
              title: this.$t("error"),
              message: "Something went wrong",
              type: "error",
            });
            this.$Progress.finish();
            this.loading = false;
          });
    },

    async performBulkAction(index) {
      
      switch (this.dateWiseCheckField[index].selectedBulkAction) {
        case 'arrived': 
          this.performBulkAttendanceActionArrived(index);
          break;
        case 'confirm': 
          this.performBulkAttendanceActionConfirmClear(index);
          break;
        defalt:
          console.log(this.dateWiseCheckField[index].selectedBulkAction);
      }
      // console.log(callIds);
      
      // console.log(this.selectBulkAction);
      // console.log(params);
    },

    async performBulkAttendanceActionArrived(index) {
      let callIds = this.selectedCallIds;
      if (callIds.length != 0) {
        let header = {
          "Authorization": this.userToken,
          "cs3-context-role": this.userRole,
          "cs3-context-clientId": this.userClientID,
        };
        await service
        .post('call/updateBulkAttendance', {
              'callIds': JSON.stringify(callIds),
              'status': this.dateWiseCheckField[index].selectedBulkAction,
              'userId': this.userID
          }, header)
        .then((res) => {
              // console.log(res);
              this.$Progress.finish();           
              this.$notify({
                title: this.$t("success"),
                message: res.data.status_message,
                type: "success",
              });
              if(this.selectedGroupCallIndex >= 0) {
                this.dateWiseCheckField[this.selectedGroupCallIndex].dateCheck = false;
              }
              this.selectedGroupCallIndex = -1;
              this.selectedCallIds = [];   
              this.dateWiseCheckField[index].selectedBulkAction = '';
              this.getData();
            })
            .catch((err) => {
              console.log(err);
              this.$notify({
                title: 'Error',
                message: "Something went wrong",
                type: "error",
              });
              this.$Progress.finish();
              this.loading = false;
            });
      }else {
        this.$notify.error({
            title: 'Error',
            message: 'Please select at least one call.'
        });
      }
    },

    performBulkAttendanceActionConfirmClear(index) {
      let callIds = this.selectedCallIds;
      if (callIds.length != 0) {
        this.$confirm("Do you want to restore to confirm and clear?", "Warning", {
        confirmButtonText: "OK",
        cancelButtonText: "Cancel",
        type: "warning",
      })
        .then(() => {
          this.$Progress.start();
          service.post('call/updateClearBulkAttendance', {
              'callIds': JSON.stringify(callIds),
              // 'user_id': this.userID
          }, {
              'Authorization': this.userToken,
              'cs3-context-role': this.userRole,
              'cs3-context-clientId': this.userClientID,
          }).
          then((res) => {
              console.log(res.data);
              this.$Progress.finish();
              this.$notify({
                  title: 'Success',
                  message: 'Calls restored to confirmed successfully.',
                  type: 'success'
              });
              this.selectedGroupCallIndex = -1;
              this.selectedCallIds = [];   
              this.dateWiseCheckField[index].selectedBulkAction = '';
              this.getData();
          }).catch((err) => {
              console.log(err);
              this.$Progress.finish();
          });
        });
      } else {
          this.$notify.error({
              title: 'Error',
              message: 'Please select at least one call.'
          });
      }
    },

    sortData() {
      console.log(this.selectedSortType);
    },

    onUpdateSubInput(index,cell) {
        // console.log(index);
        // console.log(cell);
        // console.log(this.selectedGroupCallIndex);
        if(cell.item.selected) {
          if(this.selectedGroupCallIndex == -1) {
            this.selectedGroupCallIndex = index;
            this.selectedCallIds = []
          } else if(index != this.selectedGroupCallIndex) {
            this.dateWiseCheckField[this.selectedGroupCallIndex].dateCheck = false;
            this.selectedGroupCallIndex = index;
            this.selectedCallIds = []
          }
          this.selectedCallIds.push(cell.item.id)
        }else {
          this.dateWiseCheckField[index].dateCheck = false;
          let idx = this.selectedCallIds.findIndex((id) => id == cell.item.id);
          // console.log(idx);
          if(idx >= 0) {
            this.selectedCallIds.splice(idx, 1);
          }
        }
        console.log(this.selectedCallIds);
    },
  }
};
</script>

<style>
.call-deactive{
    background-color: #ffffff;
    /* color: #fff; */
    border-radius: 5px;
    border: 1px solid #bfbdbd;
}
.go-bg-green {
  background-color: #009A00!important;
}
.go-bg-orange{
  background-color: #FB8B03!important;
}
.go-font-white {
  color: #ffffff;
}
.go-red {
  /* #FB8B03 */
  color: #db4500;
}
.date {
  margin-bottom: 10px;
  padding: 5px 5px 5px 0;
}
.date-block {
  background-color: #fefefe;
  margin-right: 10px;
  font-weight:600
}
.mr-10 {
  margin-right: 10px;
}
.mt-20 {
  margin-top: 20px!important;
}
.wj-cell {
  background: #efefef;
  text-align: center !important;
  font-size: 15px;
  height: 35px;
  padding-top: 10px !important;
  border-right: 0px !important;
}
.table-td-border-right {
  border-right: 0px;
}
.wj-header {
  border-right: 1px solid rgba(0, 0, 0, 0.2);
  border-right-width: 1px;
  border-right-style: solid;
  border-right-color: rgba(0, 0, 0, 0.2);
  padding-top: 10px;
  text-align: center;
}
.action_div {
  background-color: #fefefe;
  display: inline-block;
  font-size: 20px !important;
  padding: 5px;
  border-radius: 3px;
  padding: 5px;
  color: #000000 !important;
  border: solid 1px #000000;
  /* padding-right: 10px; */
}

.callout_action_div {
  background-color: #fefefe;
  display: inline-block;
  font-size: 14px !important;
  padding: 5px;
  border-radius: 3px;
  padding: 5px;
  color: #000000 !important;
  border: solid 1px #000000;
  /* padding-right: 10px; */
}
.btn_assign {
  padding: 6px 15px;
}
.tables {
  max-height: 95%;
  /* border-bottom: solid 1px #CCCCCC; */
  margin: 10px 0px 0px 0px;
  padding-bottom: 10px;
  overflow: hidden;
}
/* .tables:first-child {
  max-height: 450px;
  margin: 10px 10px 10px 0;
  border-bottom: solid 1px #CCCCCC;
  padding-bottom: 10px;
  overflow: hidden;
} */
.wj-flexgrid {
  max-height: 422px;
}
.wj-cell.wj-group {
  background: #e1e1e1;
  color: #444;
  text-align: left !important;
}
div.el-autocomplete-suggestion.el-popper {
  z-index: 11 !important;
}
.o-header-employee-details {
  /* font-size:16px; */
  /* color: #000000; */
}
</style>



// WEBPACK FOOTER //
// src/components/calls/jobAttendance.vue